<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="components-preview wide-md mx-auto">
                    <div class="nk-block-head nk-block-head-lg wide-sm">
                        <div class="nk-block-head-content">
                            <h4 class="nk-block-title fw-normal">Profile Data</h4>
                        </div>
                    </div>
                    <div class="nk-block nk-block-lg">
                        <div class="card">
                            <div class="card-inner">
                                <div class="preview-block">
                                    <span class="preview-title-lg overline-title">Personal Information</span>
                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">User Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.userName" disabled type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Email</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.email" disabled type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">

                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">First Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.firstName" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Middle Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.middleName" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Last Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.lastName" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Phone Number</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.phoneNumber" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Date Of Birth</label>
                                                <div class="form-control-wrap">
                                                    <datepicker v-model="registeruser.dateOfBirth" :key="render" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Gender</label>
                                                <div class="form-control-wrap">
                                                    <div class="g-4 align-center flex-wrap">
                                                        <div class="g">
                                                            <div class="custom-control custom-radio">
                                                                <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Male" id="male">
                                                                <label class="custom-control-label" for="male">Male</label>
                                                            </div>
                                                        </div>
                                                        <div class="g">
                                                            <div class="custom-control custom-radio">
                                                                <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Female" id="female">
                                                                <label class="custom-control-label" for="female">Female</label>
                                                            </div>
                                                        </div>
                                                        <div class="g">
                                                            <div class="custom-control custom-radio">
                                                                <input v-model="registeruser.gender" type="radio" class="custom-control-input" value="Transgender" id="transgender">
                                                                <label class="custom-control-label" for="transgender">Other</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="false">
                                            <div class="form-group">
                                                <label class="form-label">CNIC / National Id</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.cnic" type="text" v-bind:disabled="verified" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Country</label>
                                                <div class="form-control-wrap">
                                                    <country-dropdown v-model="registeruser.country" :values="registeruser.country" :key="render" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">City</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.city" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Postal Code</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.postalCode" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <label class="form-label">Address</label>
                                                <div class="form-control-wrap">
                                                    <textarea v-model="registeruser.address" v-bind:disabled="verified" class="form-control no-resize"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <span class="preview-title-lg overline-title">Attachments</span>

                                    <div class="row gy-4" v-bind:style=" verified ? 'pointer-events: none;' : '' ">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="form-group">
                                                <div class="form-control-wrap">
                                                    <div class="g-4 align-center flex-wrap">
                                                        <div class="g" v-if="false">
                                                            <div class="custom-control custom-radio" v-on:click="NicPicRender()">
                                                                <input v-model="registeruser.isAttachments" type="radio" class="custom-control-input" value="CNIC" id="National">
                                                                <label class="custom-control-label" for="National">CNIC / National Id</label>
                                                            </div>
                                                        </div>
                                                        <div class="g">
                                                            <div class="custom-control custom-radio" v-on:click="PassPicRender()">
                                                                <input v-model="registeruser.isAttachments" type="radio" class="custom-control-input" value="Passport" id="Passport">
                                                                <label class="custom-control-label" for="Passport">Passport</label>
                                                            </div>
                                                        </div>
                                                        <div class="g">
                                                            <div class="custom-control custom-radio" v-on:click="DriPicRender()">
                                                                <input v-model="registeruser.isAttachments" type="radio" class="custom-control-input" value="DrivingLicence" id="Driving">
                                                                <label class="custom-control-label" for="Driving">Driving Licence</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="registeruser.isAttachments=='CNIC'">
                                            <div class="form-group">
                                                <h6 class="mt-2">CNIC Front Side</h6>
                                                <div class="form-control-wrap">
                                                    <uploadimageview v-on:picPath="getCnicFrontImage" v-bind:path="registeruser.cnicFrontImagePath" :key="nicRender" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="registeruser.isAttachments=='CNIC'">
                                            <div class="form-group">
                                                <h6 class="mt-2">CNIC Back Side</h6>
                                                <div class="form-control-wrap">
                                                    <uploadimageview v-on:picPath="getCnicBackImage" v-bind:path="registeruser.cnicBackImagePath" :key="nicRender+'2'" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="registeruser.isAttachments=='Passport'">
                                            <div class="form-group">
                                                <h6 class="mt-2">Passport</h6>
                                                <div class="form-control-wrap">
                                                    <uploadimageview v-on:picPath="getPassportImage" v-bind:path="registeruser.passportImagePath" :key="passRender" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="registeruser.isAttachments=='DrivingLicence'">
                                            <div class="form-group">
                                                <h6 class="mt-2">Driving Licence Front</h6>
                                                <div class="form-control-wrap">
                                                    <uploadimageview v-on:picPath="getDrivingLicenceImage" v-bind:path="registeruser.drivingLicenceImagePath" :key="drivRender" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" v-if="registeruser.isAttachments=='DrivingLicence'">
                                            <div class="form-group">
                                                <h6 class="mt-2">Driving Licence Back</h6>
                                                <div class="form-control-wrap">
                                                    <uploadimageview v-on:picPath="getDrivingLicenceBackImage" v-bind:path="registeruser.drivingLicenceBackImagePath" :key="drivRender" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <hr class="preview-hr">
                                    <span class="preview-title-lg overline-title">Bank Details</span>

                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Bank </label>
                                                <div class="form-control-wrap">
                                                    <payment-option-dropdown v-model="registeruser.paymentOptionIdOne" :isUsdt="false" :values="registeruser.paymentOptionIdOne" :key="render" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Bank Account</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.bankAccountNoOne" v-bind:disabled="verified" type="text" class="form-control" placeholder="Type Account Number">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">

                                        </div>

                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">USDT (TRC20) Wallet </label>
                                                <div class="form-control-wrap">
                                                    <payment-option-dropdown v-model="registeruser.paymentOptionIdTwo" :isUsdt="true" :values="registeruser.paymentOptionIdTwo" :key="render" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">USDT (TRC20) Wallet Address</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.bankAccountNoTwo" v-bind:disabled="verified" type="text" class="form-control" placeholder="USDT (TRC20) Wallet">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <span class="preview-title-lg overline-title">Beneficiary Detail</span>

                                    <div class="row gy-4">
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Beneficiary Name</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.beneficiary" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Beneficiary Relation</label>
                                                <div class="form-control-wrap">
                                                    <multiselect v-model="registeruser.relation" :options="options" v-bind:disabled="verified" :multiple="false" :clear-on-select="false" :show-labels="false" :preselect-first="true">
                                                        <p slot="noResult" class="text-danger"> Oops! No found.</p>
                                                    </multiselect>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Beneficiary CNIC / National Id</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.beneficiaryCnic" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                                            <div class="form-group">
                                                <label class="form-label">Beneficiary Contact</label>
                                                <div class="form-control-wrap">
                                                    <input v-model="registeruser.beneficiaryMobile" v-bind:disabled="verified" type="text" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr class="preview-hr">
                                    <!--<span class="preview-title-lg overline-title">Security Settings</span>-->
                                    <!--<div class="row gy-4">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card card-bordered">
                <div class="card-inner-group">
                    <div class="card-inner">
                        <div class="between-center flex-wrap g-3">
                            <div class="nk-block-text">
                                <h6>Change Password</h6>
                                <p>Set a unique password to protect your account.</p>
                            </div>
                            <div class="nk-block-actions">
                                <ul class="align-center gx-3">
                                    <li class="order-md-last">
                                        <div class="custom-control custom-switch me-n2">
                                            <input v-model="registeruser.passwordChange" type="checkbox" class="custom-control-input" id="passwordChange">
                                            <label class="custom-control-label" for="passwordChange"></label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="nk-block-actions flex-shrink-sm-0" v-if="registeruser.passwordChange">
                                <ul class="align-center flex-wrap flex-sm-nowrap gx-3 gy-2">
                                    <li>
                                        <input v-model="registeruser.oldPassword" type="password" class="form-control" placeholder="Old Password">
                                    </li>
                                    <li>
                                        <input v-model="registeruser.password" type="password" class="form-control" placeholder="Password">
                                    </li>
                                    <li>
                                        <input v-model="registeruser.confirmPassword" type="password" class="form-control" placeholder="Confirm Password">-->
                                    <!--<em class="text-soft text-date fs-12px">Last changed: <span>Oct 2, 2019</span></em>-->
                                    <!--</li>
                </ul>
            </div>
        </div>
    </div>-->
                                    <!-- .card-inner -->
                                    <!--<div class="card-inner">
        <div class="between-center flex-wrap flex-md-nowrap g-3">
            <div class="nk-block-text">
                <h6>2 Factor Auth &nbsp; <span v-if="registeruser.twoFactorEnabled" class="badge badge-success ms-0">Enabled</span><span v-else class="badge badge-success ms-0">Disabled</span></h6>
                <p>Secure your account with 2FA security. When it is activated you will need to enter not only your password, but also a special code using app. You can receive this code by in mobile app. </p>
            </div>
            <div class="nk-block-actions">
                <ul class="align-center gx-3">
                    <li class="order-md-last">
                        <div class="custom-control custom-switch me-n2">
                            <input v-model="registeruser.twoFactorEnabled" type="checkbox" class="custom-control-input" id="activity-log">
                            <label class="custom-control-label" for="activity-log"></label>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>-->
                                    <!-- .card-inner -->
                                    <!--</div>--><!-- .card-inner-group -->
                                    <!--</div>--><!-- .card -->
                                    <!--</div>
    </div>-->

                                    <div class="row gy-4 mt-4">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                                            <button v-if="registeruser.submitForApproval && roleName!='Customer'" v-on:click="SaveAsApproved(true,'')" class="btn btn-primary" style="margin-right: 10px;">Save As Approved</button>
                                            <button v-if="registeruser.submitForApproval && roleName!='Customer'" v-on:click="show=true" class="btn btn-warning" style="margin-right: 10px;">Save As Rejected</button>

                                            <button v-if="!registeruser.submitForApproval && !verified" v-bind:disabled="$v.$invalid" v-on:click="SaveNewUser()" class="btn btn-primary" style="margin-right: 10px;">Submit for Approval</button>
                                            <a href="javascript:void(0)" v-on:click="GoToList()" class="btn btn-danger"> Cancel</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <rejected-reason-modal v-if="show" :show="show" @close="show=false" @Save="SaveReason" />

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>
<script>
    import { requiredIf, required } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";
    import Multiselect from "vue-multiselect";
    export default ({
        components: {
            Loading,
            Multiselect
        },
        name: 'registernewuser',
        data: function () {
            return {
                options: ['Father', 'Mother', 'Husband', 'Wife', 'Brother', 'sister', 'Son', 'Daughter'],
                show: false,
                render: 0,
                nicRender: 0,
                passRender: 0,
                drivRender: 0,
                isView: false,
                loading: false,
                verified: false,
                roleName: '',
                urlLink: '',
                active: 'PersonalInfomation',
                shortName: '',
                userImage: '',
                registeruser: {
                    id: '00000000-0000-0000-0000-000000000000',
                    email: '',
                    userName: '',
                    referrerNo: '',
                    referenceNo: '',
                    referralId: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phoneNumber: '',
                    imagePath: '',

                    dateOfBirth: '',
                    gender: '',
                    cnic: '',
                    passport: '',
                    country: '',
                    city: '',
                    street: '',
                    postalCode: '',
                    address: '',
                    roleId: '',
                    roleName: '',
                    isAttachments: '',

                    cnicFrontImagePath: '',
                    cnicBackImagePath: '',
                    passportImagePath: '',
                    drivingLicenceImagePath: '',
                    drivingLicenceBackImagePath: '',
                    twoFactorEnabled: false,
                    passwordChange: false,
                    submitForApproval: false,
                    loginHistories: [],

                    paymentOptionIdOne: '',
                    paymentOptionIdTwo: '',
                    bankAccountNoOne: '',
                    bankAccountNoTwo: '',

                    oldPassword: '',
                    password: '',
                    confirmPassword: '',
                }
            }
        },
        validations: {
            registeruser:
            {
                paymentOptionIdOne: {
                    required
                },
                bankAccountNoOne: {
                    required
                },
                address: {
                    required
                },
                city: {
                    required
                },
                country: {
                    required
                },
                dateOfBirth: {
                    required
                },
                gender: {
                    required
                },
                phoneNumber: {
                    required
                },
                cnic: {
                    required
                },
                cnicFrontImagePath: {
                    required: requiredIf((x) => {
                        if (x.isAttachments =='CNIC')
                            return true;
                        return false;
                    }),
                },
                cnicBackImagePath: {
                    required: requiredIf((x) => {
                        if (x.isAttachments =='CNIC')
                            return true;
                        return false;
                    }),
                },
                passportImagePath: {
                    required: requiredIf((x) => {
                        if (x.isAttachments =='Passport')
                            return true;
                        return false;
                    }),
                },
                drivingLicenceImagePath: {
                    required: requiredIf((x) => {
                        if (x.isAttachments =='DrivingLicence')
                            return true;
                        return false;
                    }),
                },
                drivingLicenceBackImagePath: {
                    required: requiredIf((x) => {
                        if (x.isAttachments =='DrivingLicence')
                            return true;
                        return false;
                    }),
                },

                password: {
                    required: requiredIf((x) => {
                        if (x.passwordChange)
                            return true;
                        return false;
                    }),
                },
                confirmPassword: {
                    required: requiredIf((x) => {
                        if (x.passwordChange)
                            return true;
                        return false;
                    }),
                },
            }
        },

        computed: {
            isPasswordValid: function () {

                if (this.registeruser.passwordChange) {
                    var abc = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(this.registeruser.password);
                    console.log(abc)
                }
                return false;
            },
        },

        methods: {
            NicPicRender: function () {
                this.nicRender++;
            },

            PassPicRender: function () {
                this.passRender++;
            },

            DriPicRender: function () {
                this.drivRender++;
            },

            getCnicFrontImage: function (path) {
                this.registeruser.cnicFrontImagePath = path;
            },
            getCnicBackImage: function (path) {
                this.registeruser.cnicBackImagePath = path;
            },
            getPassportImage: function (path) {
                this.registeruser.passportImagePath = path;
            },
            getDrivingLicenceImage: function (path) {
                this.registeruser.drivingLicenceImagePath = path;
            },
            getDrivingLicenceBackImage: function (path) {
                this.registeruser.drivingLicenceBackImagePath = path;
            },

            GetShortName: function () {
                var first = this.registeruser.firstName == null || this.registeruser.firstName == '' ? '' : this.registeruser.firstName.substr(0, 1);
                var second = this.registeruser.middleName == null || this.registeruser.middleName == '' ? '' : this.registeruser.middleName.substr(0, 1);
                var third = this.registeruser.lastName == null || this.registeruser.lastName == '' ? '' : this.registeruser.lastName.substr(0, 1);
                this.shortName = first + second + third;
            },

            makeActive: function (item) {
                this.active = item;
            },

            GoToList: function () {
                this.$router.push('/KycRequest');

            },

            GetRole: function (role) {
                this.registeruser.roleId = role.id;
                this.registeruser.roleName = role.name;
            },

            SaveReason: function (reason) {
                this.SaveAsApproved(false, reason)
            },

            SaveAsApproved: function (isVerified, reason) {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/account/ApprovedRegisterUser?id=' + this.registeruser.id + '&isVerified=' + isVerified + '&reason=' + reason, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                            root.loading = false;
                            root.$swal({
                                title: 'Updated!',
                                text: 'Status has been Updated successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.$router.push('/KycRequest');
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: "Something Went Wrong",
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },
            SaveNewUser: function () {
                var root = this;
                this.loading = true;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.registeruser.submitForApproval = true;
                root.$https.post('/account/UpdateRegisterUser', this.registeruser, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {
                            root.loading = false;
                            root.$swal({
                                title: 'Submited!',
                                text: 'Data has been Submited successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            }).then(function (result) {
                                if (result) {
                                    root.GoToList();
                                }
                            });
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            EditUser: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }


                root.$https.get('/Contact/UserDetail?id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.GetBaseImage(response.data.imagePath);

                            root.registeruser.id = response.data.id;
                            root.registeruser.email = response.data.email;
                            root.registeruser.userName = response.data.userName;
                            root.registeruser.referrerNo = response.data.referrerNo;
                            root.registeruser.referenceNo = response.data.referenceNo;
                            root.registeruser.referralId = response.data.referralId;
                            root.registeruser.firstName = response.data.firstName;
                            root.registeruser.middleName = response.data.middleName;
                            root.registeruser.lastName = response.data.lastName;
                            root.registeruser.phoneNumber = response.data.phoneNumber;
                            root.registeruser.roleName = response.data.roleName;
                            root.registeruser.isActive = response.data.isActive;
                            root.registeruser.imagePath = response.data.imagePath;
                            root.registeruser.isAttachments = response.data.isAttachments;

                            root.registeruser.cnicFrontImagePath = response.data.cnicFrontImagePath;
                            root.registeruser.cnicBackImagePath = response.data.cnicBackImagePath;
                            root.registeruser.passportImagePath = response.data.passportImagePath;
                            root.registeruser.drivingLicenceImagePath = response.data.drivingLicenceImagePath;
                            root.registeruser.drivingLicenceBackImagePath = response.data.drivingLicenceBackImagePath;

                            root.registeruser.dateOfBirth = response.data.dateOfBirth;
                            root.registeruser.gender = response.data.gender;
                            root.registeruser.cnic = response.data.cnic;
                            root.registeruser.passport = response.data.passport;
                            root.registeruser.country = response.data.country;
                            root.registeruser.city = response.data.city;
                            root.registeruser.street = response.data.street;
                            root.registeruser.postalCode = response.data.postalCode;
                            root.registeruser.address = response.data.address;
                            root.registeruser.roleName = response.data.roleName;
                            root.registeruser.twoFactorEnabled = response.data.twoFactorEnabled;
                            root.registeruser.loginHistories = response.data.loginHistories;

                            root.registeruser.paymentOptionIdOne = response.data.paymentOptionIdOne;
                            root.registeruser.paymentOptionIdTwo = response.data.paymentOptionIdTwo;
                            root.registeruser.bankAccountNoOne = response.data.bankAccountNoOne;
                            root.registeruser.bankAccountNoTwo = response.data.bankAccountNoTwo;
                            root.registeruser.submitForApproval = response.data.submitForApproval;

                            root.registeruser.beneficiary = response.data.beneficiary;
                            root.registeruser.relation = response.data.relation;
                            root.registeruser.beneficiaryCnic = response.data.beneficiaryCnic;
                            root.registeruser.beneficiaryMobile = response.data.beneficiaryMobile;

                            root.GetShortName();
                            root.loading = false;
                            root.isView = true;
                            root.render++;
                        }
                    },
                        function (error) {
                            root.loading = false;
                            console.log(error);
                        });
            },

            GetBaseImage: function (filePath) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.registeruser.imagePath = filePath;
                if (filePath != '' && filePath != null && filePath != undefined) {
                    root.$https.get('/Company/GetBaseImage?filePath=' + filePath, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data != null) {
                                root.userImage = response.data;

                            }
                        }, function (error) {
                            console.log(error);
                            root.loading = false;
                        });
                }
                root.loading = false;
            }

        },
        created: function () {

            var root = this;
            root.loading = true;
            root.verified = localStorage.getItem('Verified') == 'true' ? true : false;
            root.roleName = localStorage.getItem('RoleName');

            if (this.$route.query.data != undefined) {
                var userData = this.$route.query.data;

                root.GetBaseImage(userData.imagePath);

                root.registeruser.id = userData.id;
                root.registeruser.email = userData.email;
                root.registeruser.userName = userData.userName;
                root.registeruser.referrerNo = userData.referrerNo;
                root.registeruser.referenceNo = userData.referenceNo;
                root.registeruser.referralId = userData.referralId;
                root.registeruser.firstName = userData.firstName;
                root.registeruser.middleName = userData.middleName;
                root.registeruser.lastName = userData.lastName;
                root.registeruser.phoneNumber = userData.phoneNumber;
                root.registeruser.roleName = userData.roleName;
                root.registeruser.isActive = userData.isActive;
                root.registeruser.imagePath = userData.imagePath;
                root.registeruser.isAttachments = userData.isAttachments;

                root.registeruser.cnicFrontImagePath = userData.cnicFrontImagePath;
                root.registeruser.cnicBackImagePath = userData.cnicBackImagePath;
                root.registeruser.passportImagePath = userData.passportImagePath;
                root.registeruser.drivingLicenceImagePath = userData.drivingLicenceImagePath;
                root.registeruser.drivingLicenceBackImagePath = userData.drivingLicenceBackImagePath;

                root.registeruser.dateOfBirth = userData.dateOfBirth;
                root.registeruser.gender = userData.gender;
                root.registeruser.cnic = userData.cnic;
                root.registeruser.passport = userData.passport;
                root.registeruser.country = userData.country;
                root.registeruser.city = userData.city;
                root.registeruser.street = userData.street;
                root.registeruser.postalCode = userData.postalCode;
                root.registeruser.address = userData.address;
                root.registeruser.roleName = userData.roleName;
                root.registeruser.paymentOptionIdOne = userData.paymentOptionIdOne;
                root.registeruser.paymentOptionIdTwo = userData.paymentOptionIdTwo;
                root.registeruser.bankAccountNoOne = userData.bankAccountNoOne;
                root.registeruser.bankAccountNoTwo = userData.bankAccountNoTwo;
                root.registeruser.twoFactorEnabled = userData.twoFactorEnabled;
                root.registeruser.submitForApproval = userData.submitForApproval;

                root.registeruser.beneficiary = userData.beneficiary;
                root.registeruser.relation = userData.relation;
                root.registeruser.beneficiaryCnic = userData.beneficiaryCnic;
                root.registeruser.beneficiaryMobile = userData.beneficiaryMobile;

                root.GetShortName();
            }
            else {
                this.EditUser(localStorage.getItem('UserID'));
            }
        },
    })
</script>
